"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionItem = exports.default = void 0;
const react_1 = __importStar(require("react"));
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const expansion_item_styles_1 = require("./expansion-item.styles");
const sidebar_section_item_styles_1 = require("../side-bar/sidebar-section-item/sidebar-section-item.styles");
const constants_1 = require("../../../constants");
const feature_flags_1 = require("../../../feature-flags");
const hooks_1 = require("../../../hooks");
const components_1 = require("..");
const sidebar_section_styles_1 = require("../side-bar/sidebar-section/sidebar-section.styles");
const ExpansionItem = ({ id, title, items, isOpen, onHeaderClick, onCheckboxClick, onBlockIconClick, includedSelectedIds, excludedSelectedIds, isTopLevelFilterable, className, }) => {
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isProductCountsEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.ProductCounts);
    const onClick = (0, react_1.useCallback)(() => onHeaderClick(id), [id, onHeaderClick]);
    const totalCount = isProductCountsEnabled ? items.reduce(((count, { total }) => count + (total !== null && total !== void 0 ? total : 0)), 0) : null;
    const handleCheckboxClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        return onCheckboxClick(id);
    }, [id, onCheckboxClick]);
    const handleBlockIconClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        return onBlockIconClick(id);
    }, [id, onBlockIconClick]);
    return (react_1.default.createElement(expansion_item_styles_1.StyledExpansionItem, { className: className }, react_1.default.createElement(expansion_item_styles_1.StyledHeader, { onClick: onClick }, isTopLevelFilterable
        ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(sidebar_section_item_styles_1.StyledCheckbox, { checked: includedSelectedIds.includes(id), disableRipple: true, size: "small", onClick: handleCheckboxClick }), react_1.default.createElement(sidebar_section_item_styles_1.StyledBlockIcon, { "$checked": excludedSelectedIds.includes(id), onClick: handleBlockIconClick })) : undefined, react_1.default.createElement(sidebar_section_item_styles_1.StyledItemWrapper, null, react_1.default.createElement(expansion_item_styles_1.StyledTitle, null, title), totalCount !== null
        ? react_1.default.createElement(sidebar_section_item_styles_1.StyledTotal, null, totalCount) : undefined), isOpen ? react_1.default.createElement(KeyboardArrowUp_1.default, null) : react_1.default.createElement(KeyboardArrowDown_1.default, null)), react_1.default.createElement(Collapse_1.default, { in: isOpen }, react_1.default.createElement(sidebar_section_styles_1.StyledBody, null, isOpen && items.map(({ id, title: itemTitle, total }, index) => (react_1.default.createElement(sidebar_section_styles_1.StyledBodyItem, { key: id }, react_1.default.createElement(components_1.SidebarSectionItemContainer, { isUseLazyLoad: index > constants_1.NUMBER_NOT_USE_LAZY_LOAD, total: total, title: itemTitle, itemId: id, onCheckboxClick: onCheckboxClick, onBlockIconClick: onBlockIconClick, isCheckboxChecked: includedSelectedIds.includes(id), isBlockIconChecked: excludedSelectedIds.includes(id) }))))))));
};
const MemoizedExpansionItem = react_1.default.memo(ExpansionItem);
exports.default = MemoizedExpansionItem;
exports.ExpansionItem = MemoizedExpansionItem;
